(ns common.widgets.radio
  (:require ["@mui/material/FormControlLabel$default" :as FormControlLabel]
            ["@mui/material/Radio$default" :as Radio]
            ["@mui/material/RadioGroup$default" :as RadioGroup]
            ["@mui/material/Tooltip$default" :as Tooltip]
            [reagent.core :as r]))

(defn maybe-tooltip [tip & children]
  (let [element (if tip
                  [:> Tooltip {:placement :right
                               :title (r/as-element tip)}]
                  [:<>])]
    (into element children)))

(defn radio-group
  [{:keys [value on-change options]}]
  [:> RadioGroup {}
   (for [{:keys [on-select label disabled? tip] :as option} (remove nil? options)]
     ^{:key label}
     [maybe-tooltip tip
      [:> FormControlLabel {:label label
                            :disabled disabled?
                            :data-testid (str "radio-label-" label)
                            ;; the value of the RadioGroup is controlled by the Radio items,
                            ;; as the RadioGroup casts the values to strings,
                            ;; which causes issues for `nil` values.
                            :control (r/as-element
                                      [:> Radio {:checked (= value (:value option))
                                                 :on-change #(do (on-change (:value option))
                                                                 (when on-select
                                                                   (on-select)))
                                                 :inputProps {:data-testid (:data-testid option)}}])
                            :sx {:width "max-content"}}]])])
